"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _core = require("core.ui-module_site-components");
var _SecureComponent = _interopRequireDefault(require("../components/SecureComponent"));
var _TrackedComponent = _interopRequireDefault(require("../components/TrackedComponent"));
var _withPageDecoration = _interopRequireDefault(require("../components/withPageDecoration"));
var _SecurityContextHolder = require("../api/SecurityContextHolder");
var _SecurityRoutes = _interopRequireDefault(require("./SecurityRoutes"));
var _ApplicationContext = require("../api/ApplicationContext");
var _SamlLaunch = _interopRequireDefault(require("../components/authn/SamlLaunch"));
var _MenuItemTypeCode = _interopRequireDefault(require("../layout/header/MenuItemTypeCode"));
var _Menu = _interopRequireDefault(require("../api/Menu"));
var _PageHitLogger = _interopRequireDefault(require("../components/PageHitLogger"));
var _WebAnalytics = _interopRequireDefault(require("./WebAnalytics"));
var _AuthenticationConfiguration = require("../api/auth/AuthenticationConfiguration");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SecureComponentWithRouter = (0, _reactRouterDom.withRouter)(_SecureComponent.default);
const TrackedComponentWithRouter = (0, _reactRouterDom.withRouter)(_TrackedComponent.default);
const PageHitLoggerWithRouter = (0, _reactRouterDom.withRouter)(_PageHitLogger.default);
const SiteRoutes = props => {
  const [isAuthenticated, setAuthenticated] = (0, _react.useState)();
  const [authInitialized, setAuthInitialized] = (0, _react.useState)();
  const modalRootRef = (0, _react.useRef)();
  const history = (0, _reactRouterDom.useHistory)();
  (0, _react.useEffect)(() => {
    const path = window.location.pathname;
    if (path === _ApplicationContext.ApplicationContext.getLogoutPath() && authInitialized) {
      setAuthInitialized(false);
    }
    if (_ApplicationContext.ApplicationContext.isScrollToTop()) {
      window.scrollTo(0, 0);
    }
    const unlisten = history.listen((location, action) => {
      _core.PostMessage.postMessageCoreEvent('Route changed', {
        action,
        location
      });
      if (isAuthenticated !== _SecurityContextHolder.SecurityContextHolder.isAuthenticated()) {
        setAuthenticated(_SecurityContextHolder.SecurityContextHolder.isAuthenticated());
      }
      if (_ApplicationContext.ApplicationContext.isScrollToTop()) {
        window.scrollTo(0, 0);
      }
    });
    return () => {
      unlisten();
    };
  }, []);
  const defaultHomePath = () => {
    const {
      defaultPath,
      notFoundPath
    } = props;

    // Sites with token based authentication and no menus under main-menu-links will default to the page not found
    const homePath = _ApplicationContext.ApplicationContext.isLaunchToken() || _ApplicationContext.ApplicationContext.getDefaultLoginMethod() === 'token' ? notFoundPath : defaultPath;
    const menuItemList = _SecurityContextHolder.SecurityContextHolder.isAuthenticated() && _SecurityContextHolder.SecurityContextHolder.getCurrentContext().menu ? _SecurityContextHolder.SecurityContextHolder.getCurrentContext().menu.getChildren('Main-Menu-Links') : [];
    const defaultMenuItem = menuItemList.find(menuItem => menuItem.path && menuItem.path.length > 0);
    return defaultMenuItem ? defaultMenuItem.path : homePath;
  };
  const publicSiteRoutes = () => {
    const {
      loader,
      site,
      pageTitle,
      pageTitleText,
      pageTitleRight,
      sidebarTitle
    } = props;
    let menuItemList = [];
    let publicRoutes = [];
    //    const trackingEnabled = !site || typeof site.framework === 'undefined' || site.framework;
    //    const decorationEnabled = !site || typeof site.framework === 'undefined' || site.framework;
    const trackingEnabled = _ApplicationContext.ApplicationContext.getShowFramework();
    const decorationEnabled = _ApplicationContext.ApplicationContext.getShowFramework();

    // if (!SecurityContextHolder.isAuthenticated() && site?.public?.siteMenu) {
    if (site?.public?.siteMenu) {
      const menu = _Menu.default.from({
        menuItems: site?.public?.siteMenu
      });
      menuItemList = menu.getMenuItemsWithComponents();
      publicRoutes = menuItemList.filter(menuItem => menuItem.path && menuItem.path.length > 0 && (typeof menuItem.children === 'undefined' || menuItem.children.length === 0) && (menuItem.pageTitle && menuItem.pageTitle.length > 0 || menuItem.title && menuItem.title.length > 0 || menuItem.name && menuItem.name.length > 0)).map(menuItem => {
        const menuComponent = loader(menuItem.component, menuItem, props);
        const routeComponent = decorationEnabled ? (0, _withPageDecoration.default)(menuComponent, menuItem, pageTitle, pageTitleText, pageTitleRight, sidebarTitle) : menuComponent;
        return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
          exact: true,
          key: `route_${menuItem.id}`,
          path: menuItem.path,
          render: () =>
          // eslint-disable-next-line no-nested-ternary
          trackingEnabled ? /*#__PURE__*/_react.default.createElement(PageHitLoggerWithRouter, {
            key: `siteroute_${menuItem.id}`,
            menuItem: menuItem
          }, routeComponent) :
          // no framework
          routeComponent
        });
      });
    }
    return publicRoutes;
  };
  const securedSiteRoutes = () => {
    const {
      loader,
      site,
      pageTitle,
      pageTitleText,
      pageTitleRight,
      sidebarTitle
    } = props;
    let menuItemList = [];
    let securedRoutes = [];
    const trackingEnabled = true;
    const decorationEnabled = !site || typeof site.framework === 'undefined' || site.framework;
    if (_SecurityContextHolder.SecurityContextHolder.isAuthenticated() && _SecurityContextHolder.SecurityContextHolder.getCurrentContext().menu) {
      menuItemList = _SecurityContextHolder.SecurityContextHolder.getCurrentContext().menu.getMenuItemsWithComponents();
      securedRoutes = menuItemList.filter(menuItem => menuItem.path && menuItem.path.length > 0 && (menuItem.pageTitle && menuItem.pageTitle.length > 0 || menuItem.title && menuItem.title.length > 0)).map(menuItem => {
        const menuComponent = menuItem.menuItemTypeCode === _MenuItemTypeCode.default.SAML_PROVIDER ? /*#__PURE__*/_react.default.createElement(_SamlLaunch.default, null) : loader(menuItem.component, menuItem, props);
        const routeComponent = decorationEnabled ? (0, _withPageDecoration.default)(menuComponent, menuItem, pageTitle, pageTitleText, pageTitleRight, sidebarTitle) : menuComponent;
        return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
          exact: true,
          key: `route_${menuItem.id}`,
          path: menuItem.path,
          render: () =>
          // eslint-disable-next-line no-nested-ternary
          trackingEnabled ? /*#__PURE__*/_react.default.createElement(SecureComponentWithRouter, {
            key: `siteroute_${menuItem.id}`,
            menuItem: menuItem
          }, /*#__PURE__*/_react.default.createElement(TrackedComponentWithRouter, {
            menuItem: menuItem
          }, routeComponent)) :
          // no framework
          routeComponent
        });
      });
    }
    return securedRoutes;
  };
  const cssPathName = () => {
    const {
      location
    } = props;
    return location?.pathname ? location.pathname.replace(/\W/g, '-') : '';
  };
  const initializeAuthentication = () => {
    (0, _AuthenticationConfiguration.getConfiguration)(_ApplicationContext.ApplicationContext.getClientId()).then(authConfiguration => {
      _ApplicationContext.ApplicationContext.showFramework(!(authConfiguration.autoInitiateEnabled && authConfiguration.azureSSOEnabled));
      setAuthInitialized(true);
    }).catch(() => {
      // For now, just swallow the error and let the login button display
      setAuthInitialized(true);
    });
  };
  const path = window.location.pathname;
  if (path === _ApplicationContext.ApplicationContext.getLoginPath() && !authInitialized) {
    initializeAuthentication();
    return null;
  }
  if (typeof _ApplicationContext.ApplicationContext.getAzureApplicationId() !== 'undefined' && path !== _ApplicationContext.ApplicationContext.getLoginPath()) {
    _ApplicationContext.ApplicationContext.showFramework(path !== '/login/oauth2/code/');
  }
  const {
    logoutPath,
    showFramework
  } = props;
  const defaultPath = defaultHomePath();
  const externalClassName = !_SecurityContextHolder.SecurityContextHolder.isAuthenticated() ? 'external' : '';
  const frameworkClassName = showFramework ? 'framework ' : 'no-framework ';
  const routes = [];
  routes.push(...publicSiteRoutes());
  routes.push(...securedSiteRoutes());
  routes.push(...(0, _SecurityRoutes.default)(props));
  if (_SecurityContextHolder.SecurityContextHolder.isAuthenticated()) {
    if (window.location.pathname !== defaultPath && window.location.pathname !== logoutPath) {
      routes.push( /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
        exact: true,
        key: "siteroute_defaultredirect",
        render: () => /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
          to: defaultPath,
          push: true
        })
      }));
    }
  }
  return /*#__PURE__*/_react.default.createElement("main", {
    id: "content",
    className: `section body container ${frameworkClassName}${externalClassName} page-${cssPathName()}`
  },
  /*#__PURE__*/
  // eslint-disable-next-line react/jsx-props-no-spreading
  _react.default.createElement(_WebAnalytics.default, props), /*#__PURE__*/_react.default.createElement("div", {
    ref: modalRootRef,
    id: "modal-root"
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, routes));
};
SiteRoutes.propTypes = {
  defaultPath: _propTypes.default.string,
  notFoundPath: _propTypes.default.string,
  logoutPath: _propTypes.default.string,
  loginPath: _propTypes.default.string,
  history: _propTypes.default.shape({
    listen: _propTypes.default.func.isRequired
  }),
  location: _propTypes.default.shape({
    pathname: _propTypes.default.string
  }),
  showFramework: _propTypes.default.bool,
  site: _propTypes.default.shape({
    public: _propTypes.default.shape({
      siteMenu: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.shape({
        children: _propTypes.default.arrayOf(_propTypes.default.shape({
          description: _propTypes.default.string,
          icon: _propTypes.default.string,
          id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
          image: _propTypes.default.string,
          imageAlt: _propTypes.default.string,
          path: _propTypes.default.string,
          title: _propTypes.default.string,
          visible: _propTypes.default.bool
        })),
        description: _propTypes.default.string,
        icon: _propTypes.default.string,
        id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
        image: _propTypes.default.string,
        imageAlt: _propTypes.default.string,
        path: _propTypes.default.string,
        title: _propTypes.default.string,
        visible: _propTypes.default.bool
      })), _propTypes.default.shape({
        children: _propTypes.default.arrayOf(_propTypes.default.shape({
          description: _propTypes.default.string,
          icon: _propTypes.default.string,
          id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
          image: _propTypes.default.string,
          imageAlt: _propTypes.default.string,
          path: _propTypes.default.string,
          title: _propTypes.default.string,
          visible: _propTypes.default.bool
        })),
        description: _propTypes.default.string,
        icon: _propTypes.default.string,
        id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
        image: _propTypes.default.string,
        imageAlt: _propTypes.default.string,
        path: _propTypes.default.string,
        title: _propTypes.default.string,
        visible: _propTypes.default.bool
      })])
    }),
    framework: _propTypes.default.bool
  }),
  pageTitle: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  pageTitleText: _propTypes.default.string,
  pageTitleRight: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  sidebarTitle: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  loader: _propTypes.default.func.isRequired
};
SiteRoutes.defaultProps = {
  defaultPath: _ApplicationContext.ApplicationContext.getDefaultPath(),
  logoutPath: _ApplicationContext.ApplicationContext.getLogoutPath(),
  loginPath: _ApplicationContext.ApplicationContext.getLoginPath(),
  notFoundPath: _ApplicationContext.ApplicationContext.getNotFoundPath()
};
var _default = exports.default = (0, _reactRouterDom.withRouter)(SiteRoutes);
//# sourceMappingURL=SiteRoutes.js.map